export default "__VITE_ASSET__SdO7J9pG__"